import { t } from '@lingui/core/macro';
import { CommonMetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const governingLawFilterLabel = () => t({ message: 'Governing law', comment: 'Insights filter: Governing law' });
export function GoverningLawFilter() {
    return (<CommonMetadataAllowedValuesFilter name="GoverningLaw" field="metadataDocumentGoverningLaw" label={governingLawFilterLabel()}/>);
}
